import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const UserReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserReviews = async () => {
      try {
        const userId = localStorage.getItem('user_id'); // Get the logged-in user's ID
        const token = localStorage.getItem('token'); // Get the JWT token from localStorage
  
        if (!token) {
          throw new Error('No token found. Please log in.');
        }
  
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/users/${userId}/reviews`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          }
        );
  
        setReviews(response.data);
      } catch (err) {
        console.error('Error fetching user reviews:', err);
        setError(err.response?.data?.error || 'Failed to fetch your reviews.');
      }
    };
  
    fetchUserReviews();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      <h1 style={{ textAlign: 'center', color: '#007bff', marginBottom: '20px' }}>Your Feedbacks</h1>
      {error && (
        <p style={{ color: 'red', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px' }}>
          {error}
        </p>
      )}
      {reviews.length > 0 ? (
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {reviews.map((review) => (
            <li
              key={review.review_id}
              style={{
                marginBottom: '20px',
                padding: '15px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <h2 style={{ color: '#007bff', marginBottom: '10px' }}>{review.film_title}</h2>
              <p style={{ marginBottom: '10px' }}>
                <strong>Feedback:</strong> {review.review}
              </p>
              <p style={{ marginBottom: '10px', color: '#555' }}>
               <strong>Average Rating:</strong> {Number(review.average_rating || 0).toFixed(1)} / 5
              </p>           
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={() => navigate(`/films/${review.film_id}`)}
                  style={{
                    padding: '10px 15px',
                    backgroundColor: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    transition: 'background-color 0.2s',
                  }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = '#218838')}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = '#28a745')}
                >
                  View Film
                </button>
                <button
                  onClick={() => navigate(`/reviews/${review.review_id}/edit`)}
                  style={{
                    padding: '10px 15px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    transition: 'background-color 0.2s',
                  }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
                >
                  Edit Feedback
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p style={{ textAlign: 'center', fontSize: '18px', color: '#666' }}>
          You have not given any feedbacks yet.
        </p>
      )}
    </div>
  );
};

export default UserReviews;